const VAULTGRID_WEB_HOSTS = new Set([
  "vaultgrid.net",
  "www.vaultgrid.net",
  "ru.vaultgrid.net",
]);
const INTERNAL_URL_ORIGIN = "https://vaultgrid.net";

// Keep this list aligned with the routes that are actually bundled into the
// mobile release. The shared platform-information screen is the sole marketing
// exception; admin, API, asset and other marketing URLs remain in the system
// browser even when VaultGrid is installed.
export const NATIVE_APP_ROUTE_PREFIXES = Object.freeze([
  "/about",
  "/auth",
  "/accounts/confirm-email",
  "/events",
  "/clubs",
  "/menu",
  "/vault",
  "/search",
  "/shop",
  "/assistant",
  "/legal",
  "/account-deletion",
  "/host-guide",
  "/hostguide",
  "/commercial-conditions",
  "/paid-host-verification-terms",
  "/paid-host-agreement",
  "/paid-ticket-participant-terms",
  "/info",
  "/silent-disco",
  "/partner-place-map-picker",
  "/ig-gate",
]);

const isAllowedPathname = (pathname) => {
  if (pathname === "/") return true;
  return NATIVE_APP_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
};

export function isVaultGridHttpsUrl(rawUrl) {
  try {
    const url = new URL(String(rawUrl || ""));
    return url.protocol === "https:"
      && url.port === ""
      && VAULTGRID_WEB_HOSTS.has(url.hostname);
  } catch {
    return false;
  }
}

export function getNativeInternalPath(rawUrl) {
  const value = String(rawUrl || "").trim();
  if (!value || value.startsWith("//")) return null;

  const isRelativePath = value.startsWith("/");
  let url;
  try {
    url = new URL(value, isRelativePath ? INTERNAL_URL_ORIGIN : undefined);
  } catch {
    return null;
  }

  const isProductionWebLink =
    url.protocol === "https:"
    && url.port === ""
    && VAULTGRID_WEB_HOSTS.has(url.hostname);
  const isCustomAppLink =
    url.protocol === "net.vaultgrid.app:" && url.hostname === "open";
  if (!isRelativePath && !isProductionWebLink && !isCustomAppLink) return null;
  if (!isAllowedPathname(url.pathname || "/")) return null;

  return `${url.pathname || "/"}${url.search || ""}${url.hash || ""}`;
}
